<template>
  <header id="layout-header" class="container-fluid header">
    <hooper :infiniteScroll="true" :autoPlay="true" :playSpeed="4000" :transition="1000" class="container">
      <slide>
        <img class="container header__wallpaper" src="../assets/images/header_pens.jpg" alt="wallpaper">
      </slide>
      <slide>
        <img class="container header__wallpaper" src="../assets/images/header_gels.jpg" alt="wallpaper">
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
    <div class="container header__container">
      <div class="header-footer__text header-buy">
        <div class="header-buy__title">Gdzie kupić?</div>
        <div class="header-buy__description">Znajdź najbliższą lokalizację na mapie</div>
        <div class="header-buy__button"><img class="" src="../assets/images/arrow.svg" alt="logo parker"></div>
      </div>
    </div>
  </header>

</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';

export default {
    name: "HeaderComponent",
    components: {
      Hooper,
      Slide,
      HooperNavigation
  }
}
</script>

<style lang="scss">
$primary : #000000FF;
$secondary: #B7A364;
$bg-color: #fff;

.hooper {
  position: relative;
  box-sizing: border-box;
  width: 100%;
}
.hooper * {
  box-sizing: border-box;
}
.hooper-list {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.hooper-track {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
.hooper.is-vertical .hooper-track {
  flex-direction: column;
  height: 200px;
}

.hooper.is-rtl {
  direction: rtl;
}

.hooper-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.hooper-next,
.hooper-prev {
  background-color: transparent;
  border: none;
  padding: 1em;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.hooper-next.is-disabled,
.hooper-prev.is-disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.hooper-next {
  right: 0;
}
.hooper-prev {
  left: 0;
}
.hooper-navigation.is-vertical .hooper-next {
  top: auto;
  bottom: 0;
  transform: initial;
}
.hooper-navigation.is-vertical .hooper-prev {
  top: 0;
  bottom: auto;
  right: 0;
  left: auto;
  transform: initial;
}
.hooper-navigation.is-rtl .hooper-prev {
  left: auto;
  right: 0;
}
.hooper-navigation.is-rtl .hooper-next {
  right: auto;
  left: 0;
}
.hooper-pagination {
  position: absolute;
  bottom: 0;
  right: 50%;
  transform: translateX(50%);
  display: flex;
  padding: 5px 10px;
}
.hooper-indicators {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
.hooper-indicator:hover,
.hooper-indicator.is-active {
  background-color: #4285f4;
}
.hooper-indicator {
  margin: 0 2px;
  width: 12px;
  height: 4px;
  border-radius: 4px;
  border: none;
  padding: 0;
  background-color: #fff;
  cursor: pointer;
}
.hooper-pagination.is-vertical {
  bottom: auto;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.hooper-pagination.is-vertical .hooper-indicators {
  flex-direction: column;
}
.hooper-pagination.is-vertical .hooper-indicator {
  width: 6px;
}
.hooper-progress {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  background-color: #efefef;
}
.hooper-progress-inner {
  height: 100%;
  background-color: #4285f4;
  transition: 300ms;
}
.hooper-slide {
  flex-shrink: 0;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__container {
      display: flex;
      justify-content: center;
      flex-direction: column;
      position: relative;
    }

    &__wallpaper {
      max-width: 100%;
    }

    &__wrapper {
      position: absolute;
      top: 36px;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    &__title {
      font-weight: normal;
      margin: 0;
      padding: 0;
      text-transform: uppercase;
      text-align: center;
      letter-spacing: 2.85px;
      font-size: 38px;
      -webkit-filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.8));
      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.8));
    }
  }

  .header-footer {
    display: flex;
    justify-content: space-around;
    align-items: flex-end;

    &__logo {
      flex: 1;
      margin-bottom: 20px;
      padding: 0 20px;
      -webkit-filter: drop-shadow(0px 0px 3px black);
      filter: drop-shadow(0px 0px 3px black);
    }

    &__text {
      margin-top: 50px;
    }

    &__logos {
      flex: 1;
      margin-bottom: 20px;
      padding: 0 20px;
      text-align: right;
      -webkit-filter: drop-shadow(0px 0px 3px black);
      filter: drop-shadow(0px 0px 3px black);
    }

  }

  .header-buy {
    text-align: center;
    background-color: $bg-color;

    &__title {
      font-size: 50px;
      letter-spacing: 3.75px;
      color: black;
      text-align: center;
      background-color: $bg-color;
    }

    &__description {
      font-family: "Roboto", sans-serif;
      font-weight: 300;
      font-size: 18px;
      letter-spacing: 0;
    }

    &__button {
      margin-top: 10px;
      img {
        width: 4rem;
      }
    }
  }

  @media (max-width: 992px) {

    .header {
      &__title {
        letter-spacing: 1.85px;
        font-size: 24px;
      }
    }
    .header-footer {
      margin-top: 40%;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      &__logo {
        order: 1;

        & > img {
          max-width: 100px;
        }
      }

      &__text {
        order: 2;
      }

      &__logos {
        order: 3;

        & > img {
          max-width: 80px;
        }
      }

    }

    .header-buy {
      text-align: center;

      &__title {
        font-size: 25px;
        letter-spacing: 2.75px;
      }

      &__description {
        font-size: 16px;
      }

      &__button {
        img {
          width: 2rem;
        }
      }
    }
  }

  @media (max-width: 576px) {
    .header {
      &__title {
        letter-spacing: 1.0px;
        font-size: 12px;
      }
    }

    .header-footer {
      margin-top: 40%;

      &__logo {
        order: 1;

        & > img {
          max-width: 80px;
        }
      }

      &__text {
        width: 100%;
        order: 3;
      }

      &__logos {
        order: 2;

        & > img {
          max-width: 64px;
        }
      }
    }

    .header-buy {

      &__description {
        font-size: 12px;
      }

      &__button {
        & > img {
          height: 30px;
        }
      }

    }
  }

  @media (max-width: 410px) {
    .header {
    }
    .header-footer {
      &__logo {
        & > img {
          max-width: 60px;
        }
      }

      &__logos {
        & > img {
          max-width: 48px;
        }
      }
    }
  }

  @media (max-width: 310px) {

  }

</style>